// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"17c3ce99","453":"7525c720"}[chunkId] + ".chunk.js";
};